import { LanguageLocaleEnum, UserSmall } from "@/api/openapi";
import { translate } from "@/config/translator";
import { formatPhoneNumber } from "@/config/utils";
import { Persona, Text } from "@fluentui/react-components";

type ContactPersonType =
  | "buchhalter"
  | "berater_buchhaltung"
  | "lohnbuchhalter"
  | "berater_loehne";

type ContactPersonElementProps = {
  person: UserSmall;
  lang: LanguageLocaleEnum;
  type: ContactPersonType;
};

export function ContactPersonElement({
  person,
  lang,
  type,
}: ContactPersonElementProps) {
  return (
    <div className="w-full border-b border-b-neutral p-6 flex flex-col gap-4">
      <div className="w-full flex flex-row justify-center">
        <Text weight="bold" size={500}>
          {translate(
            type === "buchhalter"
              ? "accountant"
              : type === "berater_buchhaltung"
                ? "accountingAdvisor"
                : type === "lohnbuchhalter"
                  ? "payrollAdvisor"
                  : "PAYROLL_ACCOUNTANT",
            lang,
          )}
        </Text>
      </div>
      <Persona
        size="huge"
        name={person.name}
        primaryText={person.name}
        secondaryText={
          <a className="underline text-primary" href={`mailto:${person.email}`}>
            {person.email}
          </a>
        }
        tertiaryText={
          <>
            <a
              className="underline text-primary mr-2"
              href={`tel:${person.phone}`}
            >
              {`
            ${formatPhoneNumber({
              phoneNumber: person.phone ?? "",
              isMobile: false,
            })}
          `}
            </a>
            ⸱
            <a
              className="underline text-primary ml-2"
              href={`tel:${person.cell}`}
            >
              {formatPhoneNumber({
                phoneNumber: person.cell ?? "",
                isMobile: true,
              })}
            </a>
          </>
        }
      />
    </div>
  );
}
